import { IsAdmin } from "../Helpers/Utilities";
import WebServiceWrapper from "./WebServiceWrapper";

export const MDEFormService = {
    LoadMDEFormData,
    LoadMDEInformationData,
    SaveMDEFormData,
    SaveMDEInformationData,
    AddMainGridRow,
    DeleteMDERow,
};

function LoadMDEFormData(pid) {
    return WebServiceWrapper.Get(`/mdeForm/LoadMDEFormData?patientId=${pid}&isAdmin=${IsAdmin()}`);
}

function LoadMDEInformationData(pid, mdeNoId) {
    return WebServiceWrapper.Get(`/mdeForm/LoadMDEInformationData?patientId=${pid}&mdeNoId=${mdeNoId}&isAdmin=${IsAdmin()}`);
}

function SaveMDEFormData(payload) {
    return WebServiceWrapper.Post("/mdeForm/SaveMDEFormData", payload);
}

function SaveMDEInformationData(payload) {
    return WebServiceWrapper.Post("/mdeForm/SaveMDEInformationData", payload);
}

function AddMainGridRow(pid, userId, nextMdeNoId) {
    return WebServiceWrapper.Get(`/mdeForm/AddMainGridRow?patientId=${pid}&userId=${userId}&nextMdeNoId=${nextMdeNoId}`);
}

function DeleteMDERow(payload) {
    return WebServiceWrapper.Post("/mdeForm/DeleteMDERow", payload);
}
